<script>
import { mapActions } from 'pinia'
import { useCartStore } from '../stores/cart.js'

export default {
    props: {
        productId: [Number, String]
    },

    computed: {
        cartUrl() {
            if (window.Application?.config?.lang_code === "ru") {
                return "/cart/";
            }

            return "/" + window.Application?.config?.lang_code + "/cart/";
        },
        productIds() {
            if (!this.productId) {
                return [];
            }
            if (typeof this.productId === "number") {
                return [this.productId];
            }

            return this.productId
                .toString()
                .split(",")
                .map(id => parseInt(id.trim()))
                .filter(id => !isNaN(id));
        },
        inCart() {
            if (!this.productIds.length) {
                return false;
            }

            return this.productIds.every(id => this.inCartStore(id));
        }
    },
    methods: {
        ...mapActions(useCartStore, {
            inCartStore: "inCart",
            changeCart: "change"
        }),
        onCartClick() {
            this.productIds.forEach(id => {
                this.changeCart(id, 1);
            });
        }
    },
    mounted() {
        const cartStore = useCartStore();
        cartStore.setup();
    }
}
</script>


<template>
    <template v-if="inCart">
        <a class="button to_cart_all" :href="cartUrl">
            {{ $s("STR_ALREADY_CARD") }}
        </a>
    </template>

    <template v-else>
        <button class="button to_cart_all" @click="onCartClick">
            {{ $s("STR_TO_CART_ALL") }}
        </button>
    </template>
</template>